import { z } from 'zod';

import {
	MobilitySortNameV8,
	SortOrderTypeV1x0,
} from '../../../api/generated/cz.partners.bank.backofficegateway.mobility';

export const mobilityApplicationSortSchema = z
	.object({
		name: z.enum(MobilitySortNameV8),
		order: z.enum(SortOrderTypeV1x0),
	})
	.optional()
	.catch({
		name: MobilitySortNameV8.UPDATED_AT,
		order: SortOrderTypeV1x0.DESC,
	});

export type MobilityApplicationSort = z.infer<
	typeof mobilityApplicationSortSchema
>;
